<template>

    <div>

        <div class="mb-4">
            <button class="btn btn-outline-dark" 
                    type="button" 
                    data-bs-toggle="offcanvas" 
                    :data-bs-target="'#' + id" 
                    :aria-controls="id">{{ __('Select files') }}</button>
        </div>

        <div class="row row-cols-2 row-cols-md-3 row-cols-lg-4 g-4" v-if="selectedAttachments">
            <div class="col" v-for="attachment in selectedAttachments">
                <div class="card">
                    <img :src="attachment.thumbnail_url" alt="" class="card-img-top" />
                    <div class="card-body p-3">
                        <p class="card-text">
                            {{ attachment.title }} / 
                            {{ attachment.mime_type }}
                        </p>
                        <a :href="route('admin.attachments.edit', attachment)" class="btn btn-outline-primary" target="_blank">
                            {{ __('Edit') }}
                        </a>
                        <button type="button" class="btn btn-outline-warning" @click="removeAttachment(attachment.id)">{{ __('Remove') }}</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="offcanvas offcanvas-end" tabindex="-1" :id="id" :aria-labelledby="id + 'Label'" style="width: 60vw; min-width: 300px; cursor: pointer;">
            <div class="position-absolute bg-light p-2" style="transform: translateX(-100%)">
                <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
            </div>

            <iframe :src="route('admin.attachments.index', {embed: true})" frameborder="0" style="width: 100%; height: 100%;"></iframe>

        </div>

    </div>

</template>


<script>
//    import _ from 'lodash';

    import SearchFilter from '@/shared/Admin/SearchFilter';
    import SelectInput from '@/shared/Inputs/SelectInput';

    import Pagination from '@/shared/Admin/Pagination';

    export default {
        inheritAttrs: false,
        props: {
            id: {
                type: String,
                default() {
                    return `attachment-selector-${this._uid}`
                },
            },
            value: {
                default: () => []
            },
            label: String,
            error: String,
            help: String,

        },
        data() {
            return {
                selectedAttachments: [],
            }
        },
        mounted() {
            this.$inertia.on('start', (event) => {
                console.log('Closing Offcanvas');
                var myOffcanvas = document.getElementById(this.id);
                if (myOffcanvas.length) {
                    var bsOffcanvas = bootstrap.Offcanvas.getInstance(myOffcanvas);
                    bsOffcanvas.hide();
                }
            });
        },
        components: {
            SearchFilter,
            SelectInput,
            Pagination,
        },
        created() {
        },
        methods: {
            selectAttachment(attachment) {
                this.selectedAttachments.push(attachment);
            },
            removeAttachment(id) {
                this.selectedAttachments = this.selectedAttachments.filter(attachment => attachment.id !== id);
            }
        },
        watch: {
        },

    }
</script>